module.exports = __webpack_public_path__ + "img/DefaultCategory.fa0e28e8.svg";